<!-- libs/core/shell/src/lib/layout/shell-footer/shell-footer.component.html -->
<footer class="l-footer" role="contentinfo">
  <div class="l-container l-footer__row">
    <span class="l-footer__text">
      © {{ year }} {{ cfg.appName }} • env: {{ cfg.environmentName }}
    </span>

    <span class="l-footer__muted">v0.1</span>
  </div>
</footer>